(function(){
    angular
        .module('drag-canvas.dir', [])
        .directive('draggable', ['$document', '$rootScope', dragCanvas]);

    //Function to Drag the canvas area
    function dragCanvas($document, $rootScope) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var initX, initY, initMouseX, initMouseY;

                element.bind('mousedown', function($event) {

                    initX = element.prop('offsetLeft');
                    initY = element.prop('offsetTop');
                    initMouseX = $event.clientX;
                    initMouseY = $event.clientY;

                    var cursorSettings = {
                        cursor: 'url(../../imgs/closedhand.cur), move'
                    };

                    if ($rootScope.isFireFox) {
                        cursorSettings.cursor = '-moz-grabbing';
                    }

                    if ($rootScope.isChrome) {
                        cursorSettings.cursor = '-webkit-grabbing';
                    }

                    element.css(cursorSettings);

                    $document.bind('mousemove', mousemove);
                    $document.bind('mouseup', mouseup);

                    return false;
                });

                function mousemove($event) {
                    var dx = $event.clientX - initMouseX;
                    var dy = $event.clientY - initMouseY;

                    element.css({
                        top:  initY + dy + 'px',
                        left: initX + dx + 'px'
                    });

                    return false;
                }

                function mouseup() {
                    var cursorSettings = {
                        cursor: 'url(../../imgs/openhand.cur), move'
                    };

                    if ($rootScope.isFireFox) {
                        cursorSettings.cursor = '-moz-grab';
                    }

                    if ($rootScope.isChrome) {
                        cursorSettings.cursor = '-webkit-grab';
                    }

                    element.css(cursorSettings);

                    $document.unbind('mousemove');
                    $document.unbind('mouseup');
                }
            }
        }
    }

}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/drag-canvas.js